export { default } from './SearchPaginateInput';
